import React from "react";

const Flag = ({ height ="11.3px", style }) => (
  <svg
    height={height}
    style={style}
    width="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.09464 1.66278V15.7763"
      stroke="white"
      strokeWidth="1.41135"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.09464 3.07413H11.9982C13.9035 3.07413 14.3269 4.13264 12.9862 5.47343L12.1394 6.32024C11.5748 6.88478 11.5748 7.80216 12.1394 8.29613L12.9862 9.14294C14.3269 10.4837 13.833 11.5422 11.9982 11.5422H4.09464"
      stroke="white"
      strokeWidth="1.41135"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Flag;
